import { render, staticRenderFns } from "./SlideSpotlight.vue?vue&type=template&id=97cb5de0&scoped=true&"
import script from "./SlideSpotlight.vue?vue&type=script&lang=js&"
export * from "./SlideSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./SlideSpotlight.vue?vue&type=style&index=0&id=97cb5de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cb5de0",
  null
  
)

export default component.exports